export const fetchScanDetailsData = async (payload) => {
    //configure api url
    const apiUrl = global.config.trackingServiceUrl + "/"
            + payload.awbPrefix + payload.airWaybillNumber
            + "/pieces/scans?create-date=" + payload.isoCreateDate;

    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        throw new Error('Something went wrong ...');
    }

    return await response.json();
};

export const fetchShipmentData = async (payload) => {
    //configure api url
    const apiUrl = global.config.trackingServiceUrl + "/cargoawbtracking/trackAirWaybill";

    let request = [];
    const requestItem = {
        prefix: payload.awbPrefix,
        airWaybillNumber: payload.airWaybillNumber
    };
    request.push(requestItem);

    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
    });

    if (!response.ok) {
        throw new Error(response.statusText);
    }

    const data = await response.json();
    return data;
};



// WEBPACK FOOTER //
// ./src/api/scanDetailsDataApi.js